import { gql, useQuery } from "@apollo/client";

export const GET_CONFIGURED_PICKUP_HUBS = gql`
    query GetConfiguredPickupHubs($channelId: Long!) {
        getConfiguredPickupHubs(channelId: $channelId) {
            hubId
            hubName
            zipcodes
        }
    }
`;

export const GET_ALL_AVAILABLE_PICKUP_HUBS = gql`
    query GetAllAvailablePickupHubs {
        getAllAvailablePickupHubs {
            id
            name
        }
    }
`;

export const GET_UNCONFIGURED_PICKUP_HUBS = gql`
    query GetUnconfiguredPickupHubs($channelId: Long!) {
        getUnconfiguredPickupHubs(channelId: $channelId) {
            id
            name
        }
    }
`;

export interface PickupHubZipcodeType {
    hubId: number;
    hubName?: string;
    zipcodes: string[];
}

export interface WarehouseType {
    id: number;
    name?: string;
}

export interface GetConfiguredPickupHubsResponse {
    getConfiguredPickupHubs: PickupHubZipcodeType[];
}

export interface GetAllAvailablePickupHubsResponse {
    getAllAvailablePickupHubs: WarehouseType[];
}

export interface GetUnconfiguredPickupHubsResponse {
    getUnconfiguredPickupHubs: WarehouseType[];
}

export interface PickupHubZipcodeVariables {
    channelId: number;
}

export const useConfiguredPickupHubs = (channelId: number | null) => {
    return useQuery<GetConfiguredPickupHubsResponse, PickupHubZipcodeVariables>(
        GET_CONFIGURED_PICKUP_HUBS,
        {
            variables: { channelId: channelId! },
            skip: !channelId,
            fetchPolicy: 'network-only' // 每次都从服务器获取最新数据
        }
    );
};

export const useAllAvailablePickupHubs = () => {
    return useQuery<GetAllAvailablePickupHubsResponse>(GET_ALL_AVAILABLE_PICKUP_HUBS, {
        fetchPolicy: 'cache-and-network'
    });
};

export const useUnconfiguredPickupHubs = (channelId: number | null) => {
    return useQuery<GetUnconfiguredPickupHubsResponse, PickupHubZipcodeVariables>(
        GET_UNCONFIGURED_PICKUP_HUBS,
        {
            variables: { channelId: channelId! },
            skip: !channelId,
            fetchPolicy: 'cache-and-network'
        }
    );
};

